import PropTypes from 'prop-types';

import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableRow 
} from '@mui/material';

const TotalCosts = ({totalCosts}) => {
  return (
    <div className="mb-6">
      <TableContainer 
        sx={{
        borderCollapse: 'separate',
        borderRadius: '15px',
        border: '1px solid rgb(224, 224, 224)',
      }}>
        <Table aria-label="ProfitShareRevenue">
          <TableBody>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Total Costs</TableCell>
              <TableCell align='right'>{`£${totalCosts.toFixed(2)}`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default TotalCosts;

TotalCosts.propTypes = {
	totalCosts: PropTypes.number.isRequired,
};